import React from "react";


const B2CDescription = ({height, handleScroll, description }) => {

  return (
    <div className="pe-3" onScroll={handleScroll} style={{overflowY: "scroll", height: `${height}px` }} >
      <h3 className={`fs-6 mb-0 example-size`}>
        {description}
      </h3>
    </div>
  );
};

export default B2CDescription;
